<template>
	<div class="row">
		<div class="col-12">
			<div id="dashboard-carousel" class="carousel slide" data-ride="carousel" data-interval="120000">
				<div class="carousel-inner">
					<div class="carousel-item" v-bind:class="pre_selected_page == 0 ? 'active' : ''">
						<div class="d-block m-1">
							<stats-graph
								:graph_data="venue_data.bar_graph_data"
							></stats-graph>
						</div>
					</div>
					<div class="carousel-item" v-bind:class="pre_selected_page == 1 ? 'active' : ''">
						<div class="d-block m-1">
							<stats-scores
								:venue="venue"
								:venue_data="venue_data"
								radial_subtitle_1="Last Audit"
								:radial_subtitle_2="'Average score for \'' + venue.name + '\''"
							></stats-scores>
						</div>
					</div>
				</div>
				<ol class="carousel-indicators">
					<li data-target="#dashboard-carousel" data-slide-to="0" v-bind:class="pre_selected_page == 0 ? 'active' : ''"></li>
					<li data-target="#dashboard-carousel" data-slide-to="1" v-bind:class="pre_selected_page == 1 ? 'active' : ''"></li>
				</ol>
			</div>
		</div>
	</div>
</template>

<script>
	import StatsGraphComponent from './StatsGraphComponent.vue';
	import StatsAndScoresComponent from './StatsAndScoresComponent.vue'

	export default {
		components:{
			'stats-graph': StatsGraphComponent,
			'stats-scores': StatsAndScoresComponent
		},

		props:[
			'venue', 'venue_data', 'pre_selected_page'
		],

		mounted() {
			let _this = this;

			$('#dashboard-carousel').on('slide.bs.carousel', function (e) {
				_this.$emit('select_page', e.to);
			});

		},

		methods: {

		},
	}
</script>
